export interface VisitaGuiadaId {
  value: string;
}

export interface VisitaGuiadaDate {
  value: Date;
}

export interface VisitaGuiadaTime {
  value: string;
}

export class VisitaGuiada {
  constructor(
    private readonly _id: VisitaGuiadaId,
    private readonly _date: VisitaGuiadaDate,
    private readonly _time: VisitaGuiadaTime
  ) {}

  get id(): VisitaGuiadaId {
    return this._id;
  }

  get date(): VisitaGuiadaDate {
    return this._date;
  }

  get time(): VisitaGuiadaTime {
    return this._time;
  }

  isUpcoming(): boolean {
    const currentDate = new Date();
    const visitaDate = this._date.value;
    const currentDateOnly = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const visitaDateOnly = new Date(visitaDate.getFullYear(), visitaDate.getMonth(), visitaDate.getDate());
    return visitaDateOnly >= currentDateOnly;
  }

  getFormattedDate(): string {
    return this._date.value.toLocaleDateString('pt-BR', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }

  getWeekday(): string {
    return this._date.value.toLocaleDateString('pt-BR', { weekday: 'long' });
  }
} 